export default import.meta.ROLLDOWN_FILE_URL_rcJWfAsue32XwR1kdhKJSw